import { render } from "./NavigationEntry.vue?vue&type=template&id=6b9b2a18&scoped=true"
import script from "./NavigationEntry.vue?vue&type=script&lang=js"
export * from "./NavigationEntry.vue?vue&type=script&lang=js"

import "./NavigationEntry.vue?vue&type=style&index=0&id=6b9b2a18&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9b2a18"]])

export default __exports__